<!-- Modern Quick Links Filters -->
<div
  class="quick-links-filters modern-filters"
  [class.drawer-mode]="drawerMode"
>
  <!-- Header with Filters title and Clear All button -->
  <div class="filters-header-main" [ngClass]="drawerMode ? 'p-3' : 'mb-3'">
    <div class="header-content">
      <div class="header-left">
        <i class="pi pi-filter text-gray-600 mr-2"></i>
        <h2 class="filters-title">Filters</h2>
      </div>
      <!-- Clear All button positioned right -->
      <div class="header-right">
        <button
          class="clear-all-btn"
          [disabled]="loading || !hasActiveFilters()"
          [class.has-filters]="hasActiveFilters()"
          (click)="onClearFilters()"
          title="Clear all active filters"
        >
          Clear All
        </button>
      </div>
    </div>
  </div>

  <!-- Scrollable Filter Content Container -->
  <div
    class="filters-content-scroll"
    [ngClass]="drawerMode ? 'drawer-scroll' : 'default-scroll'"
  >
    <!-- Search Section -->
    <div class="search-section" [ngClass]="getSearchSectionClass()">
      <!-- Modern Search Input - Full Width -->
      <div class="search-input-wrapper">
        <p-iconfield iconPosition="left" styleClass="w-full">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input
            pInputText
            [formControl]="filterForm.controls.search"
            placeholder="Search by ID, name or slug..."
            [disabled]="loading"
            class="modern-search-input w-full"
          />
        </p-iconfield>
      </div>
    </div>

    <!-- Status Section -->
    <div
      class="filter-section status-section"
      [ngClass]="drawerMode ? 'px-3 pb-4 pt-2' : 'mb-4'"
    >
      <div class="section-header mb-3">
        <h3 class="filter-section-title">Status</h3>
      </div>

      <div class="mb-3">
        <p-multiSelect
          [options]="statusOptions"
          [formControl]="filterForm.controls.statuses"
          optionLabel="label"
          optionValue="value"
          placeholder="All statuses"
          [disabled]="loading"
          display="chip"
          appendTo="body"
          [autoZIndex]="true"
          [baseZIndex]="9999"
          class="w-full"
          [maxSelectedLabels]="3"
          selectedItemsLabel="{0} selected"
          styleClass="clean-multiselect"
        />
      </div>
    </div>

    <!-- Action Type Section -->
    <div
      class="filter-section action-type-section"
      [ngClass]="drawerMode ? 'px-3 pb-4 pt-2' : 'mb-4'"
    >
      <div class="section-header mb-3">
        <h3 class="filter-section-title">Action Type</h3>
      </div>

      <div class="mb-3">
        <p-multiSelect
          [options]="actionTypeOptions"
          [formControl]="filterForm.controls.actionTypes"
          optionLabel="label"
          optionValue="value"
          placeholder="All actions"
          [disabled]="loading"
          display="chip"
          appendTo="body"
          [autoZIndex]="true"
          [baseZIndex]="9999"
          class="w-full"
          [maxSelectedLabels]="3"
          selectedItemsLabel="{0} selected"
          styleClass="clean-multiselect"
        />
      </div>
    </div>

    <!-- Usage Limit Section - COMMENTED OUT: May be used later -->
    <!-- <div
      class="filter-section usage-limit-section"
      [ngClass]="drawerMode ? 'px-3 pb-4 pt-2' : 'mb-4'"
    >
      <div class="section-header mb-3">
        <h3 class="filter-section-title">Usage Limit</h3>
      </div>

      <div class="mb-3">
        <p-multiSelect
          [options]="usageLimitOptions"
          [formControl]="filterForm.controls.usageLimitType"
          optionLabel="label"
          optionValue="value"
          placeholder="All types"
          [disabled]="loading"
          display="chip"
          appendTo="body"
          [autoZIndex]="true"
          [baseZIndex]="9999"
          class="w-full"
          [maxSelectedLabels]="3"
          selectedItemsLabel="{0} selected"
          styleClass="clean-multiselect"
        />
      </div>
    </div> -->
  </div>
</div>
